import React from "react";
import { Badge, IconButton, makeStyles } from "@material-ui/core";
import { ClearOutlined } from "@material-ui/icons";
import { Color } from "../theme";

type Props = {
  children: React.ReactNode;
  onClear?: (e: React.SyntheticEvent) => void;
  invisible?: boolean;
};

export function ClearBadge(props: Props) {
  const classes = useStyles();

  return (
    <Badge
      invisible={props.invisible}
      badgeContent={
        <IconButton onClick={props.onClear} classes={{ root: classes.iconButton }}>
          <ClearOutlined fontSize="small" />
        </IconButton>
      }
      color="primary"
      classes={{
        badge: classes.badge
      }}
    >
      {props.children}
    </Badge>
  );
}

const useStyles = makeStyles({
  iconButton: {
    padding: "4px",
    scale: 0.75,
    backgroundColor: Color.LightGray
  },
  badge: {
    background: "none"
  }
});
